import axios from "axios";
import { IAxiosReturn } from "../interface";
import { processAxiosError } from "../processAxiosError";
import { CommentReadDto, eCommentReviewStatus } from "./interface";

export type ICommentsReturn = IAxiosReturn<CommentReadDto[]>;

export interface PatchAllHierarchyCommentDetails {
  activeContext: "Hierarchy";
  hierarchyId: string;
  newStatus: eCommentReviewStatus;
}
export interface PatchAllTlfItemCommentDetails {
  activeContext: "TlfItem";
  id: string;
  azsolId: string;
  version: number;
  newStatus: eCommentReviewStatus;
}

export type PatchAllCommentDetails =
  PatchAllHierarchyCommentDetails | PatchAllTlfItemCommentDetails;

/**
 * Update all comments' status for a hierarchy or TLF item.
 *
 * @param backEndUrl - Base backend URL
 * @param details - Details describing which comments to update and the new status
 * @param controller - AbortController to cancel the request
 * @returns List of updated comments wrapped in ICommentsReturn
 */
export const patchAllCommentStatus = async (
  backEndUrl: string,
  details: PatchAllCommentDetails,
  controller: AbortController,
): Promise<ICommentsReturn> => {
  const url =
    details.activeContext === "Hierarchy"
      ? `${backEndUrl}Hierarchy/${details.hierarchyId}/CommentStatus`
      : `${backEndUrl}TlfItems/${details.id}/CommentStatus`;

  try {
    const ret = await axios.patch(
      url,
      {
        status: details.newStatus,
      },
      {
        signal: controller.signal,
      },
    );
    return {
      success: true,
      data: ret.data,
    };
  } catch (error) {
    return processAxiosError("Update comment failed", error);
  }
};
